
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeMotorBoatOutlined as ObiVesselTypeMotorBoatOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-motor-boat-outlined.js';
 
 
 

 
 export const ObiVesselTypeMotorBoatOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-motor-boat-outlined',
   elementClass: ObiVesselTypeMotorBoatOutlinedElement,
   events: {
     
   }
  });
 
 